import * as THREE from "three";

let scene = new THREE.Scene();
scene.castShadow = true;
scene.receiveShadow = true;

export { scene };
